import moment from 'moment'

export const CONFIG = {
  API_BASE_URL:
    process.env.REACT_APP_API_BASE_URL || 'https://uat-api.oppizi.com/platform',
  GRAPHQL_API_BASE_URL:
    process.env.REACT_APP_GRAPHQL_API_BASE_URL ||
    'https://uat-api.oppizi.com/graphql',
  PATHFINDER_API_BASE_URL:
    process.env.REACT_APP_PATHFINDER_API_BASE_URL || 'http://localhost:5001',
  TRAILBLAZER_API_BASE_URL:
    process.env.REACT_APP_TRAILBLAZER_API_BASE_URL ||
    'http://localhost:5003/graphql',
  SUPERSET_URL: process.env.REACT_APP_SUPERSET_URL || 'http://localhost:8088',
  CAMPAIGN_BUILDER_URL:
    process.env.REACT_APP_CAMPAIGN_BUILDER_URL ||
    'http://localhost:3000/dashboard/campaigns/create?quoteId=QUOTE_ID',
  GOOGLE_API_KEY: 'AIzaSyCXfRmAdsdKRZJGukDU0EbDTpnn98gxztE',
  GOOGLE_API_URL:
    'https://maps.googleapis.com/maps/api/js?key=AIzaSyCXfRmAdsdKRZJGukDU0EbDTpnn98gxztE&libraries=geometry',
  GOOGLE_PLACE_URL: ({ latitude, longitude }) =>
    `http://www.google.com/maps/?q=${latitude},${longitude}`,
  FIREBASE: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  },
  USER_ROLE: {
    ADMIN: 'ADMIN',
    CITY_MANAGER: 'CITY_MANAGER',
    CLIENT_ADMIN: 'CLIENT_ADMIN',
    CLIENT: 'ROLE_CLIENT',
    DISTRIBUTOR: 'DISTRIBUTOR',
    RECRUITER: 'RECRUITER',
    SPY: 'ROLE_SPY',
  },
  STORE: {
    USER_KEY: 'user',
    API_KEY: 'apiKey',
  },
  LOCALE: 'en-US',
  DAY_OF_WEEK_ABBR: ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'],
  CUSTOM_LOCALE: 'en-custom',
  COUNTRIES: [
    {
      label: 'Australia',
      value: 'AU',
    },
    {
      label: 'New Zealand',
      value: 'NZ',
    },
  ],
}

// TODO: Probably remove this
moment.defineLocale(CONFIG.CUSTOM_LOCALE, {
  parentLocale: 'en',
  weekdaysShort: CONFIG.DAY_OF_WEEK_ABBR,
})



// WEBPACK FOOTER //
// ./src/Config/config.js